import { Injectable } from '@angular/core';
import { TrackingObject } from '../models';
import Tracking from '../data/tracking.json';
import { environment } from '../../environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { CommonService } from './common.service';

// declare const gtag: Function;
const dataLayer = window['dataLayer'];

@Injectable({
    providedIn: 'root'
})
export class GoogleService {
    private firstLoad: boolean = true;
    constructor(
        private router: Router,
        private commonSvc: CommonService
    ) {
        router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                if (this.firstLoad) {
                    this.firstLoad = false;
                    return;
                }
                const event = {
                    event: 'page_view',
                    page: {
                        path: val.url
                    },
                    congress_name: this.getShowCongressNameBrand()
                };
                console.log('this.commonSvc.debug', this.commonSvc.debug.getValue())
                if (dataLayer && !this.commonSvc.debug.getValue()) {
                    dataLayer.push(event);
                }
                console.log('event', event.event, {
                    page: {
                        path: val.url
                    },
                    congress_name: this.getShowCongressNameBrand()
                });
            }
        });
    }

    public sendGAEventById(id: number, overrides: any = undefined): void {
        let event: TrackingObject = Tracking.find(el => el.id === id);

        if (!event) {
            console.log(`No tracking data found for id: ${id}`);
            return;
        } else {
            if (overrides) {
                event = Object.assign(event, overrides);
            }
        }

        this.sendGAEventByData(event);
    }

    public sendGAEventByData(event: TrackingObject): void {
        if (!event) {
            console.log('No tracking data found');
            return;
        }

        // strip out html from label coming in (menu links)
        let tmp;

        tmp = document.createElement('div');
        tmp.innerHTML = event.label;
        event.label = tmp.textContent || tmp.innerText || '';

        tmp = document.createElement('div');
        tmp.innerHTML = event.category;
        event.category = tmp.textContent || tmp.innerText || '';

        const theEvent = {
            event: event.action,
            event_category: event.category,
            event_label: event.label,
            congress_name: this.getShowCongressNameBrand()
        };

        if (dataLayer && !this.commonSvc.debug.getValue()) {
            dataLayer.push(theEvent);
        }

        console.log('event', event.action, {
            event_category: event.category,
            event_label: event.label,
            congress_name: this.getShowCongressNameBrand(),
            id: event.id,
            description: event.description
        });
    }

    private getShowCongressNameBrand(): string {
        return localStorage.getItem(`${environment.showName}-show-name`) || '';
    }
}
